<app-switch-checkbox
  [innerId]="'checkbox_accountroles_' + role.code"
  *ngFor="let role of allAccountUserRoles"
  [checked]="hasRole(role.code)"
  (change)="onUpdateAccountRoles(role, $event)"
  [disabled]="isUpdatingAccountRole"
  placement="right"
  bsSize="sm"
>
  {{ role.code }}
</app-switch-checkbox>
